import { useAuthInvalidShopMapValue } from 'hooks/business/authShops/useAuthInvalidShops';
import { useMemo } from 'react';
import AuthInvalid from './AuthInvalid';
import Remind from './Remind';
import useRoles from 'hooks/business/useRoles';
import { TipsStatus, useCurrentChatGuaranteedAssign } from 'hooks/business/im/chatPreference';
import GuaranttedAssignTips from './GuaranttedAssignTips';
import { TodoTips } from './ChatMain/TodoTips';
import { useIsSbsMode } from 'hooks/business/useIsSbs';

interface ChatAlertProps {
  conversation: Conversation.Conversation;
}

/**
 * 待办项提醒 < 强提醒 < 无人接待 < 授权提醒
 */
const ChatAlertMain = (props: ChatAlertProps) => {
  const { conversation } = props;
  const {
    channel,
    region,
    storeId,
    remindTriggerContent,
    controlStatus,
    supervisePower,
    remindMark,
    guaranteedAssign,
  } = conversation;

  const { isSuperviser } = useRoles();

  const authInvalidShopMap = useAuthInvalidShopMapValue();
  const { [channel]: { [region]: { [storeId]: authInvalidShop } = {} } = {} } = authInvalidShopMap;

  const grantedAssignTips = useCurrentChatGuaranteedAssign();

  const showAuthInvalid = authInvalidShop !== undefined;
  /**
   * 店铺失效
   * 判断是否是迁移到TikTok
   */
  const isTokoMigrate2TT = useMemo(
    () => authInvalidShop?.authStatus === 'TOKO_TTS_MIGRATION',
    [authInvalidShop],
  );

  const showRemind = useMemo(
    () =>
      Boolean(
        remindTriggerContent &&
          remindTriggerContent.length > 0 &&
          (controlStatus || supervisePower) &&
          remindMark,
      ),
    [remindTriggerContent, controlStatus, supervisePower, remindMark],
  );

  const showGuaranttedAssignTips = useMemo(() => {
    return guaranteedAssign && grantedAssignTips === TipsStatus.Show && !isSuperviser;
  }, [guaranteedAssign, grantedAssignTips, isSuperviser]);

  if (showAuthInvalid) {
    return <AuthInvalid isTokoMigrate2TT={isTokoMigrate2TT} />;
  }

  if (showGuaranttedAssignTips) {
    return <GuaranttedAssignTips />;
  }

  if (showRemind) {
    return <Remind />;
  }

  return <TodoTips />;
};

export const ChatAlert = (props: ChatAlertProps) => {
  const isSbsMode = useIsSbsMode();

  if (isSbsMode) {
    return null;
  }

  return <ChatAlertMain {...props} />;
};
